import { useQuery } from '@tanstack/react-query';

import { eventDashboardStatsQueryOptions } from '../eventDashboardStatsQueryOptions';

type UseEventDashboardOverviewOptions = {
    eventId: number | undefined;
    timezone: string;
};

/** Full dashboard payload for alerts, top cities, seating chart, etc. No `select`. */
export function useEventDashboardOverview({ eventId, timezone }: UseEventDashboardOverviewOptions) {
    return useQuery(eventDashboardStatsQueryOptions({ eventId, timezone }));
}
